import { useState, useEffect } from 'react';
import { useAuth } from './lib/AuthContext';
import { fetchBrands, fetchMeta } from './lib/api';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

export default function App() {
  const { session, loading, signOut } = useAuth();
  const [brands, setBrands] = useState(null);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    if (!session) return;
    (async () => {
      const [b, m] = await Promise.all([fetchBrands(), fetchMeta()]);
      if (b.data) setBrands(b.data);
      if (m.data) setMeta(m.data);
    })();
  }, [session]);

  if (loading) return <div className="loading">Loading…</div>;
  if (!session) return <Login />;
  if (!brands || !meta) return <div className="loading">Loading dataset…</div>;

  return <Dashboard brands={brands} meta={meta} onSignOut={signOut} />;
}
